module.exports = __webpack_public_path__ + "static/media/emoji.f4068f55.svg";